import React, { Component } from "react";
import axios from "axios";

export class Step5Package extends Component {
  constructor(props) {
    super(props);

    this.state = {
      internshipPackage: props.formData.internshipPackage || "",
      packages: [],
      loading: true,
      error: "",
    };
  }

  componentDidMount() {
    this.getPackages();
  }

  getPackages = () => {
    axios
      .post("https://idealtechnoride.in/api/package")
      .then((res) => {
        this.setState({
          packages: res.data,
          loading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          loading: false,
          error: "Unable to load internship packages.",
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      internshipPackage: e.target.value,
      error: "",
    });
  };

  handleNext = () => {
    const { internshipPackage, packages } = this.state;

    if (!internshipPackage) {
      this.setState({
        error: "Please select an internship package.",
      });
      return;
    }

    // Find selected package
    const selectedPackage = packages.find(
      (pkg) => String(pkg.package_id) === String(internshipPackage)
    );

    if (!selectedPackage) {
      this.setState({
        error: "Selected package not found.",
      });
      return;
    }

    // Save complete package details
    this.props.updateFormData({
      internshipPackage: selectedPackage.package_id,
      selectedPackage: selectedPackage,
    });

    this.props.nextStep();
  };

  render() {
    const { packages, loading, internshipPackage, error } = this.state;

    return (
      <div className="container py-4">
        <div className="card shadow border-0">
          <div className="card-header bg-success text-white">
            <h3 className="mb-0">
              Step 5 : Select Internship Package
            </h3>
          </div>

          <div className="card-body">

            <p className="text-muted mb-4">
              Choose the internship package that best suits your requirements.
            </p>

            {loading ? (
              <div className="text-center py-5">
                <h5>Loading Packages...</h5>
              </div>
            ) : (
              <div className="row">

                {packages.map((pkg) => (

                  <div
                    className="col-lg-6 col-md-6 mb-4"
                    key={pkg.package_id}
                  >
                    <div
                      className={`card h-100 shadow-sm ${
                        String(internshipPackage) ===
                        String(pkg.package_id)
                          ? "border-success border-3"
                          : ""
                      }`}
                    >
                      <div className="card-body">

                        <div className="form-check">

                          <input
                            className="form-check-input"
                            type="radio"
                            name="internshipPackage"
                            id={`package${pkg.package_id}`}
                            value={pkg.package_id}
                            checked={
                              String(internshipPackage) ===
                              String(pkg.package_id)
                            }
                            onChange={this.handleChange}
                          />

                          <label
                            className="form-check-label fw-bold fs-5"
                            htmlFor={`package${pkg.package_id}`}
                          >
                            {pkg.package_name}
                          </label>

                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3">

                          <span className="badge bg-success px-3 py-2">
                            {pkg.package_tag}
                          </span>

                          <h5 className="text-primary mb-0">
                            ₹{Number(pkg.package_price).toLocaleString()}
                          </h5>

                        </div>

                        <hr />

                        <ul className="ps-3 mb-0">

                          {Array.isArray(pkg.feature) &&
                            pkg.feature.map((feature) => (
                              <li
                                key={feature.feature_id}
                                className="mb-2"
                              >
                                {feature.feature_name}
                              </li>
                            ))}

                        </ul>

                      </div>
                    </div>
                  </div>

                ))}

              </div>
            )}

            {error && (
              <div className="alert alert-danger">
                {error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                type="button"
                className="btn btn-success"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Step5Package;